<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav bgClass="bg-#0E0E0E" :showLang="false"></home-nav>
		</template>
		<template v-slot:content>
			<div class="pb-100rpx p-30rpx">
				<div class="me-item-bg-image p-40rpx">
					<div class="flex items-center justify-between">
						<div>
							<div>
								<span class="text-50rpx text-white font-bold">BSCN用户</span>
							</div>
							<div class="mt-10rpx">
								<span class="text-28rpx text-white">0x1234....5678</span>
							</div>
							<div class="mt-10rpx">
								<span class="text-26rpx text-white">{{$t('个人.加入时间')}}2024-01-15</span>
							</div>
						</div>
						<div class="w-150rpx h-150rpx rounded-20rpx bg-white/10 flex items-center justify-center">
							<img class="w-70rpx h-70rpx" src="~@/assets/images/pages/me/me.png" alt="" />
						</div>
					</div>
					<div class="mt-30rpx flex items-center justify-between gap-30rpx">
						<div class="flex-1 h-130rpx p-20rpx bg-white/10 rounded-20rpx">
							<div>
								<span class="text-20rpx text-white">{{$t('个人.累计收益')}}(BNB)</span>
							</div>
							<div class="mt-10rpx">
								<span class="text-44rpx text-white font-bold">125.6</span>
							</div>
						</div>
						<div class="flex-1 h-130rpx p-20rpx bg-white/10 rounded-20rpx">
							<div>
								<span class="text-20rpx text-white">{{$t('个人.推荐人数')}}</span>
							</div>
							<div class="mt-10rpx">
								<span class="text-44rpx text-white font-bold">12</span>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-30rpx">
					<div
						@click="goInvite"
						class="px-40rpx h-110rpx rounded-30rpx me-item2-bg-image flex items-center justify-between mb-30rpx">
						<img class="w-68rpx h-68rpx" src="~@/assets/images/pages/me/yqhy.png" alt="" />
						<div class="ml-20rpx flex-1">
							<div>
								<span class="text-28rpx text-white">{{$t('个人.邀请好友')}}</span>
							</div>
							<div class="mt-10rpx">
								<span class="text-28rpx text-#999">{{$t('个人.邀请好友获得推荐奖励')}}</span>
							</div>
						</div>
					</div>
					<div
						@click="goRecord"
						class="px-40rpx h-110rpx rounded-30rpx me-item2-bg-image flex items-center justify-between mb-30rpx">
						<img class="w-68rpx h-68rpx" src="~@/assets/images/pages/me/syjl.png" alt="" />
						<div class="ml-20rpx flex-1">
							<div>
								<span class="text-28rpx text-white">{{$t('个人.收益记录')}}</span>
							</div>
							<div class="mt-10rpx">
								<span class="text-28rpx text-#999">{{$t('个人.查看历史收益明细')}}</span>
							</div>
						</div>
					</div>
					<div
						@click="goRecommend"
						class="px-40rpx h-110rpx rounded-30rpx me-item2-bg-image flex items-center justify-between mb-30rpx">
						<img class="w-68rpx h-68rpx" src="~@/assets/images/pages/me/tjjl.png" alt="" />
						<div class="ml-20rpx flex-1">
							<div>
								<span class="text-28rpx text-white">{{$t('个人.推荐记录')}}</span>
							</div>
							<div class="mt-10rpx">
								<span class="text-28rpx text-#999">{{$t('个人.查行推荐用户列表')}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<menu-bar activeMenu="me"></menu-bar>
		</template>
		<template v-slot:popup>
			
		</template>
	</page-content>
</template>

<script>
import { ajaxData } from "@/request/ajax";
import homeNav from '@/components/home-nav/home-nav.vue';
import menuBar from '@/components/menu-bar/menu-bar.vue';
import router from "@/router";
import PledgeAbi from "@/abi/PledgeAbi"
import erc20Abi from "@/abi/erc20Abi"
import utils from "@/utils/utils.js";
import store from "@/store/index.js";
import { setShowAddress } from "@/libs/util";
import Web3 from "web3";
export default {
	components: {
		homeNav,
		menuBar,
	},
	data() {
		return {
			// 充值弹窗
			rechargeShow: false,
			triggered: false,
			more: 1,
			total_pledge: 0,
            usdt_balance: 0,
			all_bouns: 0,
			state_bouns: 0,
			dynamic_bouns: 0,
            recharge_number: "",
			sons: 0,
			contract_address: "0xf3708a77ea0282de751244194c304554d5a5d7ed",
			usdt_address: "0x55d398326f99059fF775485246999027B3197955",
			show_address: "",
            recharge_address: "",
			address: "",
			web3Provider: null,
			web3: null,
			users_pledges: [],
			queryInfo: {
				page: 1,
				type: 1
			},
			list: [],
			form: {
				num: ""
			}
		};
	},
	computed: {
		activeQueryInfo() {
			return this.typeList.find(item => item.id == this.queryInfo.type);
		},
		activeTitle() {
			return this.activeQueryInfo.titleKey;
		}
	},
	created() {
		let vm = this
		if (window.ethereum) {
			vm.web3Provider = window.ethereum
			vm.web3 = new Web3(vm.web3Provider);
		}
		vm.getIndex()
	},
	methods: {
		goRecord() {
			router.push({
				path: '/record',
			})
		},
		goInvite() {
			router.push({
				path: '/invite',
			})
		},
		goRecommend() {
			router.push({
				path: '/recommend',
			})
		},
        async recharge(){
            let vm = this
            console.log("11")
            if (vm.recharge_number <= 0){
                vm.$message.fail("请输入金额")
                return false;
            }
            console.log(vm.recharge_address)
            try {
                const contract = new this.web3.eth.Contract(erc20Abi, vm.usdt_address);
                // const decimals = await contract.methods.decimals().call();

                // 计算要转账的金额（考虑小数位）
                // const amount = this.recharge_number * Math.pow(10, decimals);
                const amount = vm.web3.utils.toWei(vm.recharge_number.toString(), 'ether');
                console.log("amount",amount)
                // 调用USDT合约的transfer方法
                const txData = contract.methods.transfer(vm.recharge_address, amount).encodeABI();

                // 发送交易
                const txHash = await vm.web3.eth.sendTransaction({
                    from: vm.address,
                    to: vm.usdt_address,
                    value: '0x0',
                    data: txData
                });

                // 显示成功消息
                console.log(`交易成功！交易哈希: ${txHash.transactionHash}`, 'success');

                ajaxData("recharge/post", {
                    hash: txHash.transactionHash,
                    number: vm.recharge_number,
                }).then(response => {
                    console.log(response)
                    vm.$message("操作成功")
                    vm.recharge_number = ""
                    vm.rechargeShow = false
                    // vm.getIndex()
                    // setTimeout(function (){
                    //     vm.$router.push('/?index=2');
                    // },1000);
                })

            } catch (error) {
                console.log(error.message)
                vm.$message.fail(error.message);
                // vm.$message.fail("用户取消交易");
            } finally {
                this.processing = false;
            }
            // let method = 'eth_sendTransaction'
            // let value_pad = vm.web3.utils.padLeft(vm.web3.utils.numberToHex(vm.web3.utils.toWei(vm.recharge_number.toString(), 'ether')), 64)
            // let parameters = [{
            //     // gas: vm.web3.utils.toHex(3444400),
            //     // gasPrice: vm.web3.utils.toHex(93000000000),
            //     from: vm.address,
            //     to: vm.usdt_token,
            //     value: "0x0",
            //     data: '0xa9059cbb000000000000000000000000' + vm.recharge_address.slice(2) + value_pad.slice(2),
            // }]
            // console.log("11")
            // const from = vm.address
            // //现在把所有数据整合为一个RPC请求
            // const payload = {
            //     method: method,
            //     params: parameters,
            //     from: from,
            // }
            // console.log("22")
            // window.ethereum.sendAsync(payload, function (err, response) {
            //     if (err != null) {
            //         vm.$message.fail("用户取消交易")
            //         return false
            //     }
            //     console.log(response.result)
            //
            //     ajaxData("recharge/post", {
            //         hash: response.result,
            //         number: vm.recharge_number,
            //     }).then(response => {
            //         console.log(response)
            //         vm.$message("操作成功")
            //         vm.recharge_number = ""
            //         vm.rechargeShow = false
            //         // vm.getIndex()
            //         // setTimeout(function (){
            //         //     vm.$router.push('/?index=2');
            //         // },1000);
            //     })
            // })
        },
		
		async withdraw(item) {
			let vm = this
			const contract = new vm.web3.eth.Contract(PledgeAbi, vm.contract_address);
			// let stakeOwner = await contract.methods.getStakeOwner(item.order_id).call();
			// console.log(vm.address)
			// console.log(stakeOwner.toLowerCase())
			// if (vm.address != stakeOwner.toLowerCase()){
			//     vm.$message.error("该质押ID不属于您")
			//     return false
			// }

			try {
				const owner = await contract.methods.getStakeOwner(item.order_id).call();
				if (owner == "0x0000000000000000000000000000000000000000") {
					ajaxData("/pledge/status", {
						users_pledge_id: item.id,
						hash: "",
					}).then(res => {
						console.log(res)
						vm.$message.success("该质押已经领取本金了")
						vm.getIndex()
					})
					return;
				}

				// item.usdt = "0.1"
				// item.interest = "0.001"

				const principalWei = vm.web3.utils.toWei(item.usdt.toString(), "ether");
				const rewardWei = vm.web3.utils.toWei(item.interest.toString(), "ether");

				// 处理推荐人奖励
				const validReferrers = [];
				const validRewards = [];

				const dynamic = await ajaxData("/pledge/dynamic", {
					users_pledge_id: item.id
				}).then()

				if (dynamic.code != 0) {
					vm.$message.error(dynamic.msg)
					return false;
				}
				let users_pledge_dynamics = dynamic.data.users_pledge_dynamics
				users_pledge_dynamics.forEach(function (item, index, array) {
					validReferrers.push(item.address)
					// validRewards.push(vm.web3.utils.toWei("0.001", "ether"))
					validRewards.push(vm.web3.utils.toWei(item.bouns.toString(), "ether"))
				});

				console.log(validReferrers)
				console.log(validRewards)
				// 检查余额是否足够
				const isSufficient = await contract.methods.checkSufficientUSDT(
					principalWei,
					rewardWei,
					validRewards
				).call();

				if (!isSufficient) {
					vm.$message.error("合约USDT余额不足")
					return false
				}

				const transaction = await contract.methods.withdraw(
					item.order_id,
					principalWei,
					rewardWei,
					vm.address,
					validReferrers,
					validRewards
				).send({ from: vm.address });

				ajaxData("/pledge/status", {
					users_pledge_id: item.id,
					hash: transaction.transactionHash,
				}).then(res => {
					console.log(res)
					vm.$message.success("操作成功")
					vm.getIndex()
				})
			} catch (err) {
				vm.$message.error(err.message)
				this.error = "支付失败: " + (err.message || err);
				console.error(err);
			}
		},
		getIndex() {
			ajaxData("/pledge/record").then(res => {
				console.log(res)
				this.users_pledges = res.data.users_pledges;
				this.show_address = res.data.show_address;
				this.recharge_address = res.data.recharge_address;
				this.address = res.data.address;
				this.total_pledge = res.data.total_pledge;
				this.all_bouns = res.data.all_bouns;
				this.state_bouns = res.data.state_bouns;
				this.dynamic_bouns = res.data.dynamic_bouns;
				this.usdt_balance = res.data.usdt_balance;
				this.sons = res.data.sons;
				setShowAddress(res.data.show_address)
			})
		},
		setQueryInfo(type) {
			this.queryInfo.type = type;
		},
		goToInvitation() {
			router.push({
				path: "/invite",
			});
		},
		scrolltolower() {
			console.log("滚动到底部/右边");
			this.triggered = true;
			setTimeout(() => {
				this.more = 0;
				this.triggered = false;
			}, 1000)
		},
		refresherpulling() {
			this.triggered = true;
			setTimeout(() => {
				this.triggered = false;
			}, 200)
			console.log("下拉刷新");
		}
	},
};
</script>

<style scoped>
.me-item-bg-image {
	width: 690rem;
	height: 390rem;
	background-image: url("~@/assets/images/pages/me/item1Bg.png");
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: top center;
}

.me-item2-bg-image {
		width: 690rem;
		height: 126rem;
		background-image: url("~@/assets/images/pages/team/item2Bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}
</style>
